
<template>
  <div id="_bannerMain">
    <!-- <div
      v-show="isHasBackGround"
      id="skeleton"
    ></div> -->
    <!-- <div
      v-show="!isHasBackGround"
      id="swiper"
    ></div> -->
    <Carousel
      class="myCarousel"
      v-model="Carousel.value3"
      :height="Carousel.setting.height"
      :autoplay="Carousel.setting.autoplay"
      :autoplay-speed="Carousel.setting.autoplaySpeed"
      :dots="Carousel.setting.dots"
      :radius-dot="Carousel.setting.radiusDot"
      :trigger="Carousel.setting.trigger"
      :arrow="Carousel.setting.arrow"
    >
      <CarouselItem
        v-for="(item,index) in bannerList"
        :key="index"
      >
        <div class="demo-carousel">
          <img
            :src="item?item.logoPic:''"
            alt=""
          >
        </div>
      </CarouselItem>
    </Carousel>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'realBannerMain',
  data () {
    return {
      isHasBackGround: true,
      bannerList: [],
      Carousel: {
        value3: 0,
        setting: {
          height: 420,
          autoplay: true,
          autoplaySpeed: 3000,
          dots: 'inside',
          radiusDot: false,
          trigger: 'click',
          arrow: 'hover'
        },
      },
    }
  },
  async created () {
    // 获取banner图信息
    const bannerInfo = await this.$api.get2(this.lee + '/ec/home/v1/getHomeDsListBanner', {
      url: window.location.hostname
    });
    let _bannerList = [];
    // 如果获取数据失败，则查看本地存储是否有缓存，有则用之，无则显示占位框
    if (!bannerInfo || !bannerInfo.data || !bannerInfo.data.dsListBanner || (bannerInfo.data && !bannerInfo.data.dsListBanner.length)) {
      this.bannerList = [...bannerList]
      // let bannerList = JSON.parse(sessionStorage.getItem('bannerList'));
      // if (!bannerList) {
      //   $('#skeleton').height($('#skeleton').width() / 1903 * 470);
      //   this.isHasBackGround = true;
      //   return;
      // } else {
      //   _bannerList = [...bannerList];
      // }
    } else { // 如果获取数据成功，则存入本地缓存
      sessionStorage.setItem('bannerList', JSON.stringify(bannerInfo.data.dsListBanner));
      this.bannerList = bannerInfo.data.dsListBanner;
      // _bannerList = bannerInfo.data.dsListBanner;
    }
    console.log('_bannerList', _bannerList)
    // 初始化banner轮播图
    this.isHasBackGround = false;
    // let swiperList = _bannerList.map(item => {
    //   return {
    //     href: '#',
    //     src: item.logoPic
    //   }
    // });
    // let boxWidth = $('#swiper').width();
    // let boxHeigth = boxWidth / 1903 * 470;
    // $('#swiper').height(boxHeigth);
    // $('#swiper').carousel({
    //   width: boxWidth,
    //   height: boxHeigth,
    //   speed: 1000,
    //   type: 'slide',
    //   duration: 5000,
    //   isAutoPlay: true,
    //   aImg: swiperList
    // });
  }
}
</script>

<style lang="less" scoped>
img {
  object-fit: cover;
  width: 100%;
  height: 420px;
}

// #skeleton {
//   height: 470px;
//   background-color: #eaeaea;
//   width: 100%;
// }
// #swiper {
//   height: 470px;
//   width: 100%;
// }
</style>
<style scoped>
.myCarousel {
  min-width: 1200px;
}
.myCarousel >>> .ivu-carousel-dots-inside {
  bottom: 20px;
}
.myCarousel >>> .ivu-carousel-dots li {
  margin: 0 5px;
}
.myCarousel >>> .ivu-carousel-dots li button {
  background: rgba(255, 255, 255, 0.2);
  opacity: 0.8;
  border: 1px solid #ffffff;
  border-radius: 100px;
  width: 24px;
  height: 12px;
}
.myCarousel >>> .ivu-carousel-dots .ivu-carousel-active button {
  background: #4b7ff0;
  border: 1px solid #4b7ff0;
}
.myCarousel >>> .ivu-carousel-arrow.right {
  right: 120px;
}
.myCarousel >>> .ivu-carousel-arrow.left {
  left: 120px;
}
.myCarousel >>> .ivu-carousel-arrow {
  width: 64px;
  height: 64px;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.myCarousel >>> .ivu-icon {
  font-size: 40px;
}
</style>

